<template>
  <div class="c-table" ref="appTable">
    <el-table
      class="common-el-table-styles"
      ref="table"
      :data="data"
      :height="height"
      v-loading="loading"
      border
      stripe
      @sort-change="sortChange"
    >
      <el-table-column
        v-for="(col, id) in columns"
        :key="id"
        :prop="col.key"
        :label="col.title"
        :fixed="col.fixed"
        :show-overflow-tooltip="col.overflow"
        :min-width="col.width"
        :align="col.align"
        :sortable="col.sortable"
        :sort-orders="['descending', 'ascending', null]"
      >
        <template slot-scope="scope">
          <div v-if="col.key === 'appLogo'">
            <img :src="scope.row[col.key]" width="107px" height="107px" v-if="scope.row[col.key]" />
            <img src="~/assets/images/no-image.png" width="107px" height="107px" v-else />
          </div>
          <span v-else-if="['createTime', 'updateTime'].includes(col.key)">{{ scope.row[col.key] | datetimeToSec }}</span>
          <div v-else-if="col.key === 'control'">
            <el-button type="text" size="small" @click="editClick(scope.row)">修改</el-button>
            <Poptip confirm transfer title="您确认删除该应用吗？" @on-ok="$emit('on-del', scope.row)">
              <el-button type="text" size="small">&ensp;删除</el-button>
            </Poptip>
          </div>
          <span v-else>{{ scope.row[col.key] }}</span>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>
<script>
import { timeout } from '@/common/js/utils'
export default {
  name: 'appTable',
  props: {
    data: {
      type: Array,
      default() {
        return []
      }
    },
    loading: {
      type: Boolean,
      default() {
        return false
      }
    },
    columns: {
      type: Array
    },
    height: {
      type: Number
    }
  },
  methods: {
    sortChange(column) {
      let orderName
      if (column.order === 'ascending') orderName = 'asc'
      else if (column.order === 'descending') orderName = 'desc'
      this.$emit('on-sort', { sort: column.prop, order: orderName })
    },
    editClick(row) {
      const { id } = row
      this.$router.push({ name: 'appsadd', query: { id, t: 'edit' } })
    }
  }
}
</script>
<style lang="scss" scoped>
.target-tooltip {
  position: relative;
  background: #ff6600;

  .target-close {
    position: absolute;
    top: 18px;
    right: 12px;
  }

  .target-wrap {
    width: 280px;

    header {
      width: inherit;
      padding: 8px 0 8px 8px;
      border-bottom: solid 1px #dedede;

      dl {
        width: 100%;
        line-height: 1.2;
        font-size: 14px;
        color: #333;
        font-weight: bold;
        margin: 0;

        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }

    .target-content {
      overflow: auto;
      padding: 8px 0 8px 4px;
      width: 100%;
      max-height: 318px;

      ul {
        margin: 0;
      }

      li {
        padding-top: 6px;
        display: flex;

        dd,
        dt {
          line-height: 18px;
          display: inline-block;
          margin: 0;
        }

        dt {
          color: #333;
          font-weight: 600;
        }

        dd {
          max-width: 230px;
          word-break: break-all;
          white-space: normal;
          color: #888;
        }
      }
    }
  }
}
</style>
